import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SharedLabelFormatResponse } from '../models/response-models/label-format-response.model';
import { HttpParamsService } from './http-params.service';

@Injectable({
  providedIn: 'root',
})
export class LabelFormatApiService {
  private readonly BASE: string = `${environment.inventoryApiUrl}/LabelFormats`;
  private readonly GET_ALL = (): string => `${this.BASE}`;

  constructor(
    private http: HttpClient,
    private httpParamsService: HttpParamsService,
  ) {}

  getLabelFormats(queryParams: Record<string, any>): Observable<SharedLabelFormatResponse[]> {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<SharedLabelFormatResponse[]>(this.GET_ALL(), { params });
  }
}
